document.addEventListener('DOMContentLoaded', function() {
 $(document).ready(function(){
  
  var btn = $('.product-tabs__label'),
      info = $('.product-tabs__panel');
   
    btn.click(function(e) {
        e.preventDefault();
        var index = $(this).attr('data-index');
        info.hide();
        info.eq(index).show();
        $('.product-tabs__label').removeClass('current');
        $(this).addClass('current');
    });


var btn1 = $('.inches.tab'),
      info1 = $('.rte__table-wrapper .custom-chart');
   btn1.click(function(e) {
        e.preventDefault();
        var index1 = $(this).index();
        info1.hide();
        info1.eq(index1).show();
      info1.removeClass('actice');
      info1.eq(index1).addClass('actice');
        $('.inches').removeClass('cusrrent');
        $(this).addClass('cusrrent');
    });

   
});

$('.styled-product .size .bothdiv').click(function(event) {
 //console.log(2);
    $(this).toggleClass('is-active').next(".option-contenet").stop().slideToggle(400).toggleClass("active");
  });
 
$('.styled-product .swatch_options .option-contenet .custom-items .swatch-all .swatch-element22').click(function(event) {
  $(this).parents('.custom-items').find('.swatch-all').find('.swatch-element22').removeClass('active');
  $(this).addClass('active');
  if ($(this).hasClass("soldout")) {//alert('soldout');                                 
  $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').find('.text').text('Sold out');
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').css('pointer-events','none'); 
  }else if($(this).hasClass("preorder")){//alert('preorder');
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').show();
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').find('.text').text('preorder');
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').css('pointer-events','auto'); 
  }else if($(this).hasClass("available")){//alert('available');
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').show();
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').find('.text').text('Add to cart');
    $(this).parents('.styled-product').find('.custstyle').find('.form .customstylen .style-with-button').css('pointer-events','auto'); 
  }else{
    
  }
  var vid=$(this).attr('data-metavid');console.log(vid);
 $(this).parents('.swatch_options').addClass('tttttttt');
  $(this).parents('.swatch_options').siblings('.styleone').find('.form').find('#custom_style').val(vid);
  $(this).parents('.swatch_options').siblings('.styletwo').find('.styletwo').find('.form').find('#custom_style2').val(vid);
});


//    if (window.matchMedia('(max-width: 767px)').matches) {
// $('.customm-product .main-style-first').hide();
//   }else{
  // $(window).on("scroll", function () {
  //   // Show & Hide Text On-Scroll
  //   if ($(window).scrollTop() > 650) {
  //    $('.customm-product .main-style-first').show(1000);
  //    $(".customm-product .tab-main").fadeOut(1000);
  //     $('.customm-product .cusrt-wrapper-contener').fadeOut(1000);
  //     $('.customm-product .main-swatches-custome').fadeOut(1000);
  //   } else {
  //     $(".customm-product .tab-main").fadeIn(600);
  //     $('.customm-product .main-swatches-custome').fadeIn(600);
  //     $('.customm-product .cusrt-wrapper-contener').fadeIn(600);
  //      $('.customm-product .main-style-first').hide(300);
  //   }
  // });
  // }

 var firstvale= $('.customm-product .swatch-thumb.default:first').attr('data-color');
  if(firstvale) {
    firstvale = firstvale.toLowerCase();
  }
  
  $('.customm-product .curstom-color').find('.color-name').html(firstvale);
  
  $('.customm-product .color-metafields .swatch-thumb').mouseover(function(){
    var colorname = $(this).addClass('active').attr('data-color');
    if(colorname){
      colorname = colorname.toLowerCase();  
    }
    $('.customm-product .curstom-color').find('.color-name').html(colorname);
  });
  $('.customm-product .color-metafields .swatch-thumb').mouseout(function(){
    $(this).removeClass('active');
  });



// navigation
$('.sr-menu-main').find('.main-menu-item').click(function() {
  $(this).siblings().removeClass('custom-menu');
  $(this).addClass('custom-menu');
$(this).find('.sr-inner-menu').show();
  
});

$('.grandchildnV_drop-2').click(function() {
  $('.customheadtext').toggleClass('grandchileNa');
});
  
});


     document.querySelectorAll('.tab-title').forEach(tab => {
  tab.addEventListener('click', () => {
    const tabName = tab.getAttribute('data-tab');
    if(tabName == 'true-fit'){
        window.dataLayer.push({
          event: 'true_fit_link_click',
          eventAction: 'true_fit_link_click',
        });
        window.Shopify.analytics.publish('true_fit_link_clicked', {
          source: 'true_fit_widget',
          timestamp: new Date().toISOString()
        });

    }
    // Remove active classes
    document.querySelectorAll('.tab-title').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

    // Add active class to the clicked tab and corresponding content
    tab.classList.add('active');
    document.querySelector(`.${tabName}`).classList.add('active');
  });
     
});

  
window.addEventListener("change", function () {
  setTimeout(function(){
  var currentPageUrl = document.URL;
  var url = new URL(currentPageUrl);
  var isVariantUrl = url.searchParams.get("variant");
    

$( ".customm-product .hidden.custom-countinue div").each(function(index,value) {
var current_v = $(this).attr('data-id');
 if (current_v.length != 0) {
if(current_v == isVariantUrl)
{
  // $(this).css('display','block');
  var datapolicy = $(this).attr('datapolicy');
  if(datapolicy=='continue'){
    $('.customm-product').find('.product-form .product-form__buttons .product-form__submit span').html('Preorder');
  }
  if(datapolicy=='deny'){
    if ($('.customm-product').find('.product__info-container .custom-waitlist.prodt').hasClass("hidden") ) {
    $('.customm-product').find('.product__info-container .custom-waitlist.prodt').removeClass('hidden');
    }
      
  }
}else{
// $(this).css('display','none');
  
}
  }else{

}

  
});


    
    }, 800);
});

// FAQ page

window.onload = function() {
  var descriptions = document.querySelectorAll('.pages-answers');
  // if (descriptions.length > 0) {
  //   descriptions[0].classList.add("displayBlock");
  //   descriptions[0].previousElementSibling.classList.add('active');
  // }
};
  
function customerPage(e){
       let active1 = document.querySelectorAll(".pages-question");
       let active2 = document.querySelectorAll(".pages-answers");
       for(let j = 0; j < active2.length; j++){
        if(active2[j]!=e.nextElementSibling){
           active2[j].classList.remove("displayBlock");
         }
       }
       for(let j = 0; j < active1.length; j++){
            if(active1[j]!=e){
               active1[j].classList.remove("active");
             }
       }
      e.classList.add('active');
      e.nextElementSibling.classList.toggle('displayBlock');
  }
if ($(window).width() < 767){
window.addEventListener('load', function() {
      const swiper = new Swiper("#custommmobile", { // Optional parameters
          direction: "horizontal",
          slidesPerView: 1,
          keyboard: {
            enabled: true
          },

          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
      clickable: true
          },

          // Navigation arrows
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
          },
      });
});
}
window.addEventListener("load", (event) => {

if (window.matchMedia('(max-width: 767px)').matches) {
  // $('.customm-collection .collection.page-width').find('#product-grid').removeClass('second').addClass('first');
  $('.customm-collection .filter .mobileview.mviews').find('.line').on("click", function(){
    //var mobilpaginM = $(this).html();
    $(this).addClass("active");
   $(this).siblings("").removeClass("active");
  //localStorage.setItem("mobpagionM", mobilpaginM);
 
});
//   setTimeout(function(){
// var mobcrtpagM = localStorage.getItem("mobpagionM");
//     if(mobcrtpagM == null){
//      jQuery(".mobileview.mviews .first.line").trigger("click"); 
//     }else{
// $('.customm-collection .filter .mobileview.mviews .line').each(function(index){
//     var MallinM = $(this).html();
//     if (MallinM.length != 0) {
//       if(parseInt(MallinM) == parseInt(mobcrtpagM)){
        
//         $(this).siblings("").removeClass("active");
//         $(this).addClass('active');
//         $('.customm-collection .mobileview.mviews').find('.active').trigger('click');
         
//       }
//     }
//   });
//     }  
//   }, 1900); 
}else{
  // $('.customm-collection .collection.page-width').find('#product-grid').addClass('second');
$('.customm-collection .filter .desktopview.dviews').find('.line').on("click", function(){
  $(this).addClass("active");
  $(this).siblings("").removeClass("active");
  // var curpagin = $(this).html();
  // localStorage.setItem("currentpagion", curpagin);
 
// });
// setTimeout(function(){

// var crtpag = localStorage.getItem("currentpagion");
//  $('.customm-collection .filter .desktopview.dviews .line').each(function(index){
//     var allin = $(this).html();
//     if (allin.length != 0) {
//       if(parseInt(allin) == parseInt(crtpag)){
        
//         $(this).siblings("").removeClass("active");
//         $(this).addClass('active');
//         $('.customm-collection .desktopview.dviews').find('.active').trigger('click');
         
//       }
//     }
 });
//     }, 1900);
  
}

  
});
document.addEventListener('DOMContentLoaded', function() {
var custominve = $('.product__inventory').find('.customqty').text();
  var tt = custominve.match(/\d+/); //alert(tt);
  var dtpolicy=$('.variant-customm .customsize').find('label').attr('datai-policy');
  var daya_trtrt = $('.variant-customm .customsize').find('label').attr('daya-int');
  var parintwerew = parseInt(daya_trtrt);
  if(tt === null){
    $('.hura-notify-btn').show();
  }else{
    $('.hura-notify-btn').hide();
  }
  if(parseInt(tt) > parseInt(5)){
  $('.cutneinve').addClass('custom-inver');
}else{
  $('.cutneinve').removeClass('custom-inver');
}
  if(tt=== null && dtpolicy=='deny' && parintwerew < 1 ){
  $('.customm-product .product-form .product-form__buttons.mainporidcyt').hide(); 
}else{
  $('.customm-product .product-form .product-form__buttons.mainporidcyt').show(); 
}


$('.mobile-facets__clear').on("click", function(){
  // custom js trigger -09-01-25
  // var preloader = document.querySelector('.preloader');
  //   preloader.style.display = 'inline-flex';
      setTimeout(function(){
        if (window.matchMedia('(max-width: 767px)').matches) {
        $('.customm-collection .mobileview.mviews').find('.active').trigger('click');
        }else{
        $('.customm-collection .desktopview.dviews').find('.active').trigger('click');
        }
        //preloader.style.display = 'none';
    }, 2400); 
      // end 09-01-25
});
if (window.matchMedia('(max-width: 767px)').matches) {
  $('.facets-container-drawer .active-facets').on("click", function(){
    // var preloader = document.querySelector('.preloader');
    // preloader.style.display = 'inline-flex';
    setTimeout(function(){
    $('.customm-collection .mobileview.mviews').find('.active').trigger('click');
        // preloader.style.display = 'none';
       }, 2400);
  });


}

    window.addEventListener("change", function () {
             //collection page quick-view
               $('.customm-collection').find('.quick-add-modal__content-info .cus_product .variant-customm .customsize label').click(function () { //alert(2);

                var policy = $(this).attr('data-polyc'); // Fix typo
                var dintvt = parseInt($(this).attr('data-inventory')); // Fix typo
                var ptags = $(this).attr('data-tags'); // Fix typo
                
                //alert(policy + '-' + dintvt + '=' + ptags);
                 if (policy === "continue" && dintvt === 0 && ptags === "preorder") {
        
                   setTimeout(function() {
        $(".customm-collection.overflow-hidden").find(".quick-add-modal__content-info").find(".cus_product .product__info-container .product-form .product-form__buttons .product-form__submit span").text('Preorder');
    }, 1200);
                 }
  
               });
              // product page


            });


});  
jQuery(document).ready(function(){
	jQuery('.customm-product .tab-main_new .tab-title').on('click', function(){
		let tab_name = jQuery(this).data('tab');
        console.log("tab_name",tab_name)
		if( tab_name == 'style-with' ) {
			jQuery('.customm-product .styled-product-wrapper.second-option').hide();
		}else if(tab_name == 'true-fit'){
          jQuery('.customm-product .styled-product-wrapper.second-option').show()
          if (jQuery('.main-swatches-custome-size-height').length) {
              jQuery('.main-swatches-custome-size-height').addClass('customhidden');
          }
          if (jQuery('.custom-size-height-variant').length) {
              jQuery('.custom-size-height-variant').addClass('customhidden');
          }
        }else {
			jQuery('.customm-product .styled-product-wrapper.second-option').show()
            if (jQuery('.main-swatches-custome-size-height').length) {
                jQuery('.main-swatches-custome-size-height').removeClass('customhidden');
            }
            if (jQuery('.custom-size-height-variant').length) {
                jQuery('.custom-size-height-variant').removeClass('customhidden');
            }
		}
	});
})

document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.customm-index .video');

    const ensureVideosPlaying = () => {
        videos.forEach(video => {
            if (video.paused) {
                video.play().catch(err => console.error('Error playing video:', err));
            }
        });
    };

    ensureVideosPlaying();

    document.addEventListener('click', ensureVideosPlaying);

    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            ensureVideosPlaying();
        }
    });

    setInterval(ensureVideosPlaying, 1000);
});

// Collection Page Filter 
document.addEventListener("DOMContentLoaded", () => {
    const sortButtons = document.querySelectorAll(".r13-sort-button");

    // Set active class on page load
    setActiveSortOption();

    sortButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent default button behavior
            event.stopPropagation(); 
            const sortBy = button.getAttribute("data-sort-by");

            updateProducts(sortBy);
            updateURL(sortBy);
            updatePaginationLinks(sortBy);

            // Update active class
            updateActiveClass(button);
        });
    });

    function updateProducts(sortBy) {

        const collection = document.querySelector(".collection");
        if (collection) {
            collection.classList.add("loading");
        }
        // Get current filters from the URL
        const currentParams = new URLSearchParams(window.location.search);

        // Update or add the sort_by parameter
        currentParams.set("sort_by", sortBy);

        // Build the updated URL
        const collectionHandle = window.location.pathname.split("/").pop();
        const url = `/collections/${collectionHandle}?${currentParams.toString()}`;

        // Fetch updated product grid via AJAX
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const updatedProducts = doc.querySelector(".product-grid");
                const currentProducts = document.querySelector(".product-grid");

                if (updatedProducts && currentProducts) {
                    currentProducts.innerHTML = updatedProducts.innerHTML;
                  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                }

                if (collection) {
                    collection.classList.remove("loading");
                }
            })
            .catch((error) => {
              console.error("Error updating products:", error)
              if (collection) {
                  collection.classList.remove("loading");
              }
            });
    }

    function updateURL(sortBy) {
        // Get current filters from the URL
        const currentParams = new URLSearchParams(window.location.search);

        // Update or add the sort_by parameter
        currentParams.set("sort_by", sortBy);

        // Update the browser's URL without reloading the page
        const newURL = `${window.location.pathname}?${currentParams.toString()}`;
        window.history.pushState(null, "", newURL);
    }

    function updateActiveClass(activeButton) {
        // Remove active class from all buttons
        sortButtons.forEach((button) => button.classList.remove("active"));

        // Add active class to the clicked button
        activeButton.classList.add("active");
    }

    function setActiveSortOption() {
        const currentParams = new URLSearchParams(window.location.search);
        const sortBy = currentParams.get("sort_by");

        // If a sort_by parameter exists, set the active class
        if (sortBy) {
            sortButtons.forEach((button) => {
                if (button.getAttribute("data-sort-by") === sortBy) {
                    button.classList.add("active");
                }
            });
        }
    }

function updatePaginationLinks(sortBy) {
    // Get the current URL's query parameters
    const currentParams = new URLSearchParams(window.location.search);

    // Update or add the sort_by parameter for the pagination links
    currentParams.set("sort_by", sortBy);

    // Loop through all pagination links and update their href attributes
    const paginationLinks = document.querySelectorAll(".pagination a");

    paginationLinks.forEach((link) => {
        // Create a new URL object based on the current link's href and the current page's origin
        const url = new URL(link.href, window.location.origin);

        // Append the currentParams (which includes sort_by) to the existing query string
        url.search = url.search ? `${url.search}&${currentParams.toString()}` : `?${currentParams.toString()}`;

        // Update the href attribute with the new URL
        link.href = url.toString();
    });
}
}); 

jQuery(document).ready(function(){
	jQuery(".r13-clear-all").on('click', function(){ 

        jQuery(".mobile-facets__clear")[0].click(); 
		
        jQuery(".r13-col-filter-wrapper .mobile-facets__list .mobile-facets__item .mobile-facets__checkbox").prop('checked', false);
        
        jQuery(".r13-col-filter-wrapper .r13-sorting-filters li .r13-sort-button").removeClass('active');
	});
});

jQuery(document).ready(function () {
      if (sessionStorage.getItem('hideAnnouncementBar')) {
          jQuery('.announcement-bar-section').hide();
      }
  
      jQuery('.hide-announcement-bar').on('click', function (e) {
          e.preventDefault();
          jQuery(this).parents('.announcement-bar-section').hide();
          sessionStorage.setItem('hideAnnouncementBar', true);
      });

    jQuery('.menu-drawer__menu.level-3 li details summary').on('click', function(){
      // $(this).parents('li').siblings().find('details').removeAttr('open');
    });

    // const observer = new MutationObserver(function(mutations) {
    //       mutations.forEach(function(mutation) {
    //           if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
    //               const detailsElement = mutation.target;
    //               const closeButton = document.querySelector('.r13-header-search-close');
                  
    //               if (detailsElement.hasAttribute('open')) {
    //                   closeButton.classList.add('active');
    //               } else {
    //                   closeButton.classList.remove('active');
    //               }
    //           }
    //       });
    //   });
      
    //   document.querySelectorAll('details').forEach(function(details) {
    //       observer.observe(details, {
    //           attributes: true,  
    //           attributeFilter: ['open']
    //       });
    //   });

  const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const detailsElement = mutation.target;
                const closeButton = document.querySelector('.r13-header-search-close');
    
                if (detailsElement.hasAttribute('open')) {
                    closeButton.classList.add('active');
                } else {
                    closeButton.classList.remove('active');
                }
            }
        });
    });
    
    document.querySelectorAll('.header__search details').forEach(function(details) {
        observer.observe(details, {
            attributes: true,  
            attributeFilter: ['open']
        });
    });

  });

jQuery(document).ready(function(){
    if (jQuery('body').attr('class').includes('customm-product.gift-product')) {
        jQuery('form[data-type="add-to-cart-form"]').on('submit', function(e){
            let $form = jQuery(this);
            let $checkbox = $form.find('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
            let $emailField = $form.find('input[name="properties[Recipient email]"]');

            if ($checkbox.is(':checked')) {
                let $recipientField = $emailField.closest('.recipient-fields__field');
                let $formMessage = $recipientField.find('.form__message');
                let $errorMessage = $formMessage.find('.error-message');

                if ($emailField.val().trim() === '') {
                    e.preventDefault(); // Prevent form submission
                    $formMessage.removeClass('hidden');
                    $errorMessage.text('Recipient email is required.');
                } else {
                    $formMessage.addClass('hidden');
                    $errorMessage.text('');
                }
            }
        });
    }
});

jQuery(document).ready(function(){
    function updateCartIcon() {
        jQuery.getJSON('/cart.js', function(cart) {
            if (cart.item_count > 0) {
                jQuery('.header__icon.header__icon--cart').addClass('mobile-margin-right');
            } else {
                jQuery('.header__icon.header__icon--cart').removeClass('mobile-margin-right');
            }
        });
    }

    // Run on page load to check cart status
    updateCartIcon();

    // Listen for Shopify cart updates (Works with AJAX cart updates)
    jQuery(document).on('cart:updated', function() {
        updateCartIcon();
    });

    // If using Shopify's AJAX API for adding/removing items
    jQuery(document).on('click', '.product-form__submit', function(){
        setTimeout(updateCartIcon, 1000); // Delay to allow Shopify API update
    });

    jQuery(document).on('click', '.cart-remove-button', function(){
        setTimeout(updateCartIcon, 1000);
    });
});


// $(document).ready(function () {
//     var currentUrl = new URL(window.location.href);
//     var viewBy = currentUrl.searchParams.get("view_by");

//     if (viewBy) {
//         updatePaginationLinks(viewBy);
//     }

//     $(".line").click(function () {
//         var value = $(this).text().trim();
//         var newUrl = new URL(window.location.href);
//         newUrl.searchParams.set("view_by", value);
//         window.history.pushState({}, "", newUrl);

//         updatePaginationLinks(value);
//     });

//     window.addEventListener("popstate", function () {
//         var updatedUrl = new URL(window.location.href);
//         var updatedViewBy = updatedUrl.searchParams.get("view_by");
//         updatePaginationLinks(updatedViewBy);
//     });

//     function updatePaginationLinks(viewByValue) {
//         $(".pagination a").each(function () {
//             var paginationUrl = new URL($(this).attr("href"), window.location.origin);
//             paginationUrl.searchParams.set("view_by", viewByValue);
//             $(this).attr("href", paginationUrl.toString());
//         });
//     }
// });

$(document).ready(function () {
    var currentUrl = new URL(window.location.href);
    var viewBy = currentUrl.searchParams.get("view_by");

    if (viewBy) {
        updatePaginationLinks(viewBy);
    }

    $(".line").click(function () {
        var value = $(this).text().trim();
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set("view_by", value);
        window.history.pushState({}, "", newUrl);

        updatePaginationLinks(value);
    });

    window.addEventListener("popstate", function () {
        var updatedUrl = new URL(window.location.href);
        var updatedViewBy = updatedUrl.searchParams.get("view_by");
        if (updatedViewBy) { // Prevent adding undefined
            updatePaginationLinks(updatedViewBy);
        }
      location.reload();
    });

    function updatePaginationLinks(viewByValue) {
        if (!viewByValue) return; // Prevent adding "undefined"

        $(".pagination a").each(function () {
            var paginationUrl = new URL($(this).attr("href"), window.location.origin);
            paginationUrl.searchParams.set("view_by", viewByValue);
            $(this).attr("href", paginationUrl.toString());
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            const target = mutation.target;

            // Only track the outer <details> element (.sr-main-menu > li > details)
            if (target.matches(".sr-main-menu > li > details")) {
                
                // If the user manually closes the outer menu, allow it
                if (target.dataset.userClosed === "true") {
                    return; // Skip restoring if the user closed it
                }

                // Restore "open" if JavaScript forcefully removed it
                if (!target.hasAttribute("open")) {
                    target.setAttribute("open", "");
                }

                // Restore "menu-opening" class if removed
                if (!target.classList.contains("menu-opening")) {
                    target.classList.add("menu-opening");
                }

                // Ensure inner elements work normally but keep the "menu-opening" class
                target.querySelectorAll(".menu-drawer__menu > li > details").forEach(innerEl => {
                    innerEl.setAttribute("open", ""); // Let inner elements work normally

                    // Restore "menu-opening" class if removed
                    if (!innerEl.classList.contains("menu-opening")) {
                        innerEl.classList.add("menu-opening");
                    }
                });
            }
        });
    });

    // Observe only .sr-main-menu > li > details
    document.querySelectorAll(".sr-main-menu > li > details").forEach(el => {
        observer.observe(el, { attributes: true, attributeFilter: ["class", "open"] });

        // Allow user to manually close the outer menu
        el.querySelector("summary").addEventListener("click", function (event) {
            const detailsElement = this.parentElement;

            if (detailsElement.hasAttribute("open")) {
                detailsElement.removeAttribute("user-closed"); // Reset when opened
                delete detailsElement.dataset.userClosed;
            } else {
                detailsElement.removeAttribute("open"); // Allow manual close
                detailsElement.dataset.userClosed = "true"; // Mark as user closed
                detailsElement.classList.remove("menu-opening"); // Also remove menu-opening class
            }
        });
    });
});

